var cov_1hbovy3e54 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Select/BoxList.tsx",
      hash = "3480a7b1d00ed45fc9a67e6e7048a97eee9c2d24",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Select/BoxList.tsx",
    statementMap: {
      "0": {
        start: {
          line: 16,
          column: 18
        },
        end: {
          line: 16,
          column: 59
        }
      },
      "1": {
        start: {
          line: 17,
          column: 18
        },
        end: {
          line: 17,
          column: 26
        }
      },
      "2": {
        start: {
          line: 19,
          column: 21
        },
        end: {
          line: 21,
          column: 1
        }
      },
      "3": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 29,
          column: 16
        }
      },
      "4": {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 32,
          column: 50
        }
      },
      "5": {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 33,
          column: 48
        }
      },
      "6": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 34,
          column: 47
        }
      },
      "7": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 36,
          column: 58
        }
      },
      "8": {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 37,
          column: 60
        }
      },
      "9": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 41,
          column: 49
        }
      },
      "10": {
        start: {
          line: 45,
          column: 64
        },
        end: {
          line: 45,
          column: 74
        }
      },
      "11": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 46,
          column: 42
        }
      },
      "12": {
        start: {
          line: 46,
          column: 24
        },
        end: {
          line: 46,
          column: 42
        }
      },
      "13": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 47,
          column: 32
        }
      },
      "14": {
        start: {
          line: 51,
          column: 28
        },
        end: {
          line: 51,
          column: 38
        }
      },
      "15": {
        start: {
          line: 52,
          column: 4
        },
        end: {
          line: 53,
          column: 27
        }
      },
      "16": {
        start: {
          line: 52,
          column: 17
        },
        end: {
          line: 52,
          column: 32
        }
      },
      "17": {
        start: {
          line: 53,
          column: 9
        },
        end: {
          line: 53,
          column: 27
        }
      },
      "18": {
        start: {
          line: 57,
          column: 83
        },
        end: {
          line: 57,
          column: 93
        }
      },
      "19": {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 76,
          column: 5
        }
      },
      "20": {
        start: {
          line: 61,
          column: 27
        },
        end: {
          line: 61,
          column: 48
        }
      },
      "21": {
        start: {
          line: 62,
          column: 10
        },
        end: {
          line: 73,
          column: 11
        }
      },
      "22": {
        start: {
          line: 80,
          column: 54
        },
        end: {
          line: 80,
          column: 64
        }
      },
      "23": {
        start: {
          line: 82,
          column: 4
        },
        end: {
          line: 82,
          column: 41
        }
      },
      "24": {
        start: {
          line: 82,
          column: 30
        },
        end: {
          line: 82,
          column: 41
        }
      },
      "25": {
        start: {
          line: 84,
          column: 34
        },
        end: {
          line: 84,
          column: 49
        }
      },
      "26": {
        start: {
          line: 85,
          column: 4
        },
        end: {
          line: 86,
          column: 50
        }
      },
      "27": {
        start: {
          line: 85,
          column: 21
        },
        end: {
          line: 85,
          column: 36
        }
      },
      "28": {
        start: {
          line: 86,
          column: 9
        },
        end: {
          line: 86,
          column: 50
        }
      },
      "29": {
        start: {
          line: 86,
          column: 36
        },
        end: {
          line: 86,
          column: 50
        }
      },
      "30": {
        start: {
          line: 88,
          column: 4
        },
        end: {
          line: 97,
          column: 5
        }
      },
      "31": {
        start: {
          line: 101,
          column: 63
        },
        end: {
          line: 101,
          column: 73
        }
      },
      "32": {
        start: {
          line: 102,
          column: 22
        },
        end: {
          line: 111,
          column: 10
        }
      },
      "33": {
        start: {
          line: 103,
          column: 29
        },
        end: {
          line: 103,
          column: 48
        }
      },
      "34": {
        start: {
          line: 104,
          column: 6
        },
        end: {
          line: 107,
          column: 7
        }
      },
      "35": {
        start: {
          line: 105,
          column: 8
        },
        end: {
          line: 105,
          column: 21
        }
      },
      "36": {
        start: {
          line: 106,
          column: 8
        },
        end: {
          line: 106,
          column: 26
        }
      },
      "37": {
        start: {
          line: 108,
          column: 6
        },
        end: {
          line: 109,
          column: 30
        }
      },
      "38": {
        start: {
          line: 108,
          column: 38
        },
        end: {
          line: 108,
          column: 54
        }
      },
      "39": {
        start: {
          line: 109,
          column: 11
        },
        end: {
          line: 109,
          column: 30
        }
      },
      "40": {
        start: {
          line: 110,
          column: 6
        },
        end: {
          line: 110,
          column: 16
        }
      },
      "41": {
        start: {
          line: 112,
          column: 4
        },
        end: {
          line: 120,
          column: 5
        }
      },
      "42": {
        start: {
          line: 124,
          column: 77
        },
        end: {
          line: 124,
          column: 87
        }
      },
      "43": {
        start: {
          line: 125,
          column: 4
        },
        end: {
          line: 139,
          column: 6
        }
      },
      "44": {
        start: {
          line: 126,
          column: 23
        },
        end: {
          line: 126,
          column: 44
        }
      },
      "45": {
        start: {
          line: 127,
          column: 6
        },
        end: {
          line: 138,
          column: 7
        }
      },
      "46": {
        start: {
          line: 143,
          column: 65
        },
        end: {
          line: 143,
          column: 75
        }
      },
      "47": {
        start: {
          line: 144,
          column: 4
        },
        end: {
          line: 144,
          column: 28
        }
      },
      "48": {
        start: {
          line: 144,
          column: 17
        },
        end: {
          line: 144,
          column: 28
        }
      },
      "49": {
        start: {
          line: 145,
          column: 18
        },
        end: {
          line: 145,
          column: 32
        }
      },
      "50": {
        start: {
          line: 146,
          column: 18
        },
        end: {
          line: 146,
          column: 52
        }
      },
      "51": {
        start: {
          line: 147,
          column: 4
        },
        end: {
          line: 157,
          column: 5
        }
      },
      "52": {
        start: {
          line: 161,
          column: 101
        },
        end: {
          line: 161,
          column: 111
        }
      },
      "53": {
        start: {
          line: 162,
          column: 25
        },
        end: {
          line: 162,
          column: 64
        }
      },
      "54": {
        start: {
          line: 162,
          column: 42
        },
        end: {
          line: 162,
          column: 56
        }
      },
      "55": {
        start: {
          line: 164,
          column: 21
        },
        end: {
          line: 164,
          column: 73
        }
      },
      "56": {
        start: {
          line: 166,
          column: 6
        },
        end: {
          line: 171,
          column: 9
        }
      },
      "57": {
        start: {
          line: 174,
          column: 4
        },
        end: {
          line: 185,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 17,
            column: 18
          },
          end: {
            line: 17,
            column: 19
          }
        },
        loc: {
          start: {
            line: 17,
            column: 24
          },
          end: {
            line: 17,
            column: 26
          }
        },
        line: 17
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 28,
            column: 3
          }
        },
        loc: {
          start: {
            line: 28,
            column: 48
          },
          end: {
            line: 38,
            column: 3
          }
        },
        line: 28
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 40,
            column: 3
          }
        },
        loc: {
          start: {
            line: 40,
            column: 23
          },
          end: {
            line: 42,
            column: 3
          }
        },
        line: 40
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 44,
            column: 2
          },
          end: {
            line: 44,
            column: 3
          }
        },
        loc: {
          start: {
            line: 44,
            column: 13
          },
          end: {
            line: 48,
            column: 3
          }
        },
        line: 44
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 50,
            column: 2
          },
          end: {
            line: 50,
            column: 3
          }
        },
        loc: {
          start: {
            line: 50,
            column: 44
          },
          end: {
            line: 54,
            column: 3
          }
        },
        line: 50
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 56,
            column: 2
          },
          end: {
            line: 56,
            column: 3
          }
        },
        loc: {
          start: {
            line: 56,
            column: 53
          },
          end: {
            line: 77,
            column: 3
          }
        },
        line: 56
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 60,
            column: 18
          },
          end: {
            line: 60,
            column: 19
          }
        },
        loc: {
          start: {
            line: 60,
            column: 28
          },
          end: {
            line: 74,
            column: 9
          }
        },
        line: 60
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 79,
            column: 2
          },
          end: {
            line: 79,
            column: 3
          }
        },
        loc: {
          start: {
            line: 79,
            column: 30
          },
          end: {
            line: 98,
            column: 3
          }
        },
        line: 79
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 100,
            column: 2
          },
          end: {
            line: 100,
            column: 3
          }
        },
        loc: {
          start: {
            line: 100,
            column: 19
          },
          end: {
            line: 121,
            column: 3
          }
        },
        line: 100
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 102,
            column: 34
          },
          end: {
            line: 102,
            column: 35
          }
        },
        loc: {
          start: {
            line: 102,
            column: 59
          },
          end: {
            line: 111,
            column: 5
          }
        },
        line: 102
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 123,
            column: 2
          },
          end: {
            line: 123,
            column: 3
          }
        },
        loc: {
          start: {
            line: 123,
            column: 16
          },
          end: {
            line: 140,
            column: 3
          }
        },
        line: 123
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 125,
            column: 20
          },
          end: {
            line: 125,
            column: 21
          }
        },
        loc: {
          start: {
            line: 125,
            column: 30
          },
          end: {
            line: 139,
            column: 5
          }
        },
        line: 125
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 142,
            column: 2
          },
          end: {
            line: 142,
            column: 3
          }
        },
        loc: {
          start: {
            line: 142,
            column: 18
          },
          end: {
            line: 158,
            column: 3
          }
        },
        line: 142
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 160,
            column: 2
          },
          end: {
            line: 160,
            column: 3
          }
        },
        loc: {
          start: {
            line: 160,
            column: 11
          },
          end: {
            line: 186,
            column: 3
          }
        },
        line: 160
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 162,
            column: 37
          },
          end: {
            line: 162,
            column: 38
          }
        },
        loc: {
          start: {
            line: 162,
            column: 42
          },
          end: {
            line: 162,
            column: 56
          }
        },
        line: 162
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 41,
            column: 11
          },
          end: {
            line: 41,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 41,
            column: 11
          },
          end: {
            line: 41,
            column: 31
          }
        }, {
          start: {
            line: 41,
            column: 35
          },
          end: {
            line: 41,
            column: 49
          }
        }],
        line: 41
      },
      "1": {
        loc: {
          start: {
            line: 45,
            column: 12
          },
          end: {
            line: 45,
            column: 50
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 45,
            column: 26
          },
          end: {
            line: 45,
            column: 50
          }
        }],
        line: 45
      },
      "2": {
        loc: {
          start: {
            line: 46,
            column: 4
          },
          end: {
            line: 46,
            column: 42
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 46,
            column: 4
          },
          end: {
            line: 46,
            column: 42
          }
        }, {
          start: {
            line: 46,
            column: 4
          },
          end: {
            line: 46,
            column: 42
          }
        }],
        line: 46
      },
      "3": {
        loc: {
          start: {
            line: 52,
            column: 4
          },
          end: {
            line: 53,
            column: 27
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 52,
            column: 4
          },
          end: {
            line: 53,
            column: 27
          }
        }, {
          start: {
            line: 52,
            column: 4
          },
          end: {
            line: 53,
            column: 27
          }
        }],
        line: 52
      },
      "4": {
        loc: {
          start: {
            line: 82,
            column: 4
          },
          end: {
            line: 82,
            column: 41
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 82,
            column: 4
          },
          end: {
            line: 82,
            column: 41
          }
        }, {
          start: {
            line: 82,
            column: 4
          },
          end: {
            line: 82,
            column: 41
          }
        }],
        line: 82
      },
      "5": {
        loc: {
          start: {
            line: 82,
            column: 8
          },
          end: {
            line: 82,
            column: 28
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 82,
            column: 8
          },
          end: {
            line: 82,
            column: 15
          }
        }, {
          start: {
            line: 82,
            column: 19
          },
          end: {
            line: 82,
            column: 28
          }
        }],
        line: 82
      },
      "6": {
        loc: {
          start: {
            line: 85,
            column: 4
          },
          end: {
            line: 86,
            column: 50
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 85,
            column: 4
          },
          end: {
            line: 86,
            column: 50
          }
        }, {
          start: {
            line: 85,
            column: 4
          },
          end: {
            line: 86,
            column: 50
          }
        }],
        line: 85
      },
      "7": {
        loc: {
          start: {
            line: 86,
            column: 9
          },
          end: {
            line: 86,
            column: 50
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 86,
            column: 9
          },
          end: {
            line: 86,
            column: 50
          }
        }, {
          start: {
            line: 86,
            column: 9
          },
          end: {
            line: 86,
            column: 50
          }
        }],
        line: 86
      },
      "8": {
        loc: {
          start: {
            line: 90,
            column: 9
          },
          end: {
            line: 94,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 90,
            column: 9
          },
          end: {
            line: 90,
            column: 17
          }
        }, {
          start: {
            line: 91,
            column: 10
          },
          end: {
            line: 93,
            column: 21
          }
        }],
        line: 90
      },
      "9": {
        loc: {
          start: {
            line: 95,
            column: 9
          },
          end: {
            line: 95,
            column: 92
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 95,
            column: 9
          },
          end: {
            line: 95,
            column: 21
          }
        }, {
          start: {
            line: 95,
            column: 25
          },
          end: {
            line: 95,
            column: 92
          }
        }],
        line: 95
      },
      "10": {
        loc: {
          start: {
            line: 104,
            column: 6
          },
          end: {
            line: 107,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 104,
            column: 6
          },
          end: {
            line: 107,
            column: 7
          }
        }, {
          start: {
            line: 104,
            column: 6
          },
          end: {
            line: 107,
            column: 7
          }
        }],
        line: 104
      },
      "11": {
        loc: {
          start: {
            line: 108,
            column: 6
          },
          end: {
            line: 109,
            column: 30
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 108,
            column: 6
          },
          end: {
            line: 109,
            column: 30
          }
        }, {
          start: {
            line: 108,
            column: 6
          },
          end: {
            line: 109,
            column: 30
          }
        }],
        line: 108
      },
      "12": {
        loc: {
          start: {
            line: 144,
            column: 4
          },
          end: {
            line: 144,
            column: 28
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 144,
            column: 4
          },
          end: {
            line: 144,
            column: 28
          }
        }, {
          start: {
            line: 144,
            column: 4
          },
          end: {
            line: 144,
            column: 28
          }
        }],
        line: 144
      },
      "13": {
        loc: {
          start: {
            line: 146,
            column: 18
          },
          end: {
            line: 146,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 146,
            column: 18
          },
          end: {
            line: 146,
            column: 31
          }
        }, {
          start: {
            line: 146,
            column: 35
          },
          end: {
            line: 146,
            column: 52
          }
        }],
        line: 146
      },
      "14": {
        loc: {
          start: {
            line: 148,
            column: 49
          },
          end: {
            line: 148,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 148,
            column: 49
          },
          end: {
            line: 148,
            column: 54
          }
        }, {
          start: {
            line: 148,
            column: 58
          },
          end: {
            line: 148,
            column: 70
          }
        }],
        line: 148
      },
      "15": {
        loc: {
          start: {
            line: 149,
            column: 9
          },
          end: {
            line: 155,
            column: 9
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 150,
            column: 10
          },
          end: {
            line: 152,
            column: 16
          }
        }, {
          start: {
            line: 154,
            column: 10
          },
          end: {
            line: 154,
            column: 95
          }
        }],
        line: 149
      },
      "16": {
        loc: {
          start: {
            line: 151,
            column: 13
          },
          end: {
            line: 151,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 151,
            column: 13
          },
          end: {
            line: 151,
            column: 22
          }
        }, {
          start: {
            line: 151,
            column: 26
          },
          end: {
            line: 151,
            column: 48
          }
        }],
        line: 151
      },
      "17": {
        loc: {
          start: {
            line: 154,
            column: 27
          },
          end: {
            line: 154,
            column: 77
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 154,
            column: 35
          },
          end: {
            line: 154,
            column: 53
          }
        }, {
          start: {
            line: 154,
            column: 56
          },
          end: {
            line: 154,
            column: 77
          }
        }],
        line: 154
      },
      "18": {
        loc: {
          start: {
            line: 168,
            column: 9
          },
          end: {
            line: 168,
            column: 79
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 168,
            column: 51
          },
          end: {
            line: 168,
            column: 69
          }
        }, {
          start: {
            line: 168,
            column: 72
          },
          end: {
            line: 168,
            column: 79
          }
        }],
        line: 168
      },
      "19": {
        loc: {
          start: {
            line: 168,
            column: 9
          },
          end: {
            line: 168,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 168,
            column: 9
          },
          end: {
            line: 168,
            column: 16
          }
        }, {
          start: {
            line: 168,
            column: 20
          },
          end: {
            line: 168,
            column: 48
          }
        }],
        line: 168
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0
    },
    b: {
      "0": [0, 0],
      "1": [0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Select/BoxList.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { Component } from 'react';
import { getLocale } from '../locale'; // import icons from '../icons'

import { getKey } from '../utils/uid';
import List from '../AnimationList';
import Spin from '../Spin'; // import Input from '../Input'

import Checkbox from '../Checkbox/Checkbox';
import { selectClass } from './styles';
import BoxOption from './BoxOption';
import LazyList from '../AnimationList/LazyList';
import { getCustomList } from './utils';
var ScaleList = (cov_1hbovy3e54.s[0]++, List(['fade', 'scale-y'], 'fast', 'flex'));
cov_1hbovy3e54.s[1]++;

var emptyFunc = function emptyFunc() {
  cov_1hbovy3e54.f[0]++;
};

var DefaultValue = (cov_1hbovy3e54.s[2]++, {
  columnWidth: 160
});

var BoxList =
/*#__PURE__*/
function (_Component) {
  _inherits(BoxList, _Component);

  var _super = _createSuper2(BoxList);

  function BoxList(props) {
    var _this;

    _classCallCheck(this, BoxList);

    cov_1hbovy3e54.f[1]++;
    cov_1hbovy3e54.s[3]++;
    _this = _super.call(this, props); // fake events

    _this.handleMouseMove = void 0;
    cov_1hbovy3e54.s[4]++;
    props.bindOptionFunc('handleHover', emptyFunc);
    cov_1hbovy3e54.s[5]++;
    props.bindOptionFunc('hoverMove', emptyFunc);
    cov_1hbovy3e54.s[6]++;
    props.bindOptionFunc('getIndex', emptyFunc);
    cov_1hbovy3e54.s[7]++;
    _this.handleSelectAll = _this.handleSelectAll.bind(_assertThisInitialized(_this));
    cov_1hbovy3e54.s[8]++;
    _this.handleRenderItem = _this.handleRenderItem.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(BoxList, [{
    key: "getText",
    value: function getText(key) {
      cov_1hbovy3e54.f[2]++;
      cov_1hbovy3e54.s[9]++;
      return (cov_1hbovy3e54.b[0][0]++, this.props.text[key]) || (cov_1hbovy3e54.b[0][1]++, getLocale(key));
    }
  }, {
    key: "getWidth",
    value: function getWidth() {
      cov_1hbovy3e54.f[3]++;

      var _ref = (cov_1hbovy3e54.s[10]++, this.props),
          _ref$columnWidth = _ref.columnWidth,
          columnWidth = _ref$columnWidth === void 0 ? (cov_1hbovy3e54.b[1][0]++, DefaultValue.columnWidth) : _ref$columnWidth,
          columns = _ref.columns;

      cov_1hbovy3e54.s[11]++;

      if (columns === -1) {
        cov_1hbovy3e54.b[2][0]++;
        cov_1hbovy3e54.s[12]++;
        return columnWidth;
      } else {
        cov_1hbovy3e54.b[2][1]++;
      }

      cov_1hbovy3e54.s[13]++;
      return columnWidth * columns;
    }
  }, {
    key: "handleSelectAll",
    value: function handleSelectAll(_, checked) {
      cov_1hbovy3e54.f[4]++;

      var _ref2 = (cov_1hbovy3e54.s[14]++, this.props),
          datum = _ref2.datum,
          data = _ref2.data;

      cov_1hbovy3e54.s[15]++;

      if (checked) {
        cov_1hbovy3e54.b[3][0]++;
        cov_1hbovy3e54.s[16]++;
        datum.add(data);
      } else {
        cov_1hbovy3e54.b[3][1]++;
        cov_1hbovy3e54.s[17]++;
        datum.remove(data);
      }
    }
  }, {
    key: "handleRenderItem",
    value: function handleRenderItem(data, groupIndex) {
      var _this2 = this;

      cov_1hbovy3e54.f[5]++;

      var _ref3 = (cov_1hbovy3e54.s[18]++, this.props),
          datum = _ref3.datum,
          keygen = _ref3.keygen,
          columns = _ref3.columns,
          multiple = _ref3.multiple,
          onChange = _ref3.onChange,
          renderItem = _ref3.renderItem,
          lineHeight = _ref3.lineHeight;

      cov_1hbovy3e54.s[19]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          style: {
            height: lineHeight
          },
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 59,
            columnNumber: 7
          }
        }, data.map(function (d, i) {
          cov_1hbovy3e54.f[6]++;
          var isActive = (cov_1hbovy3e54.s[20]++, datum.check(d));
          cov_1hbovy3e54.s[21]++;
          return (
            /*#__PURE__*/
            React.createElement(BoxOption, {
              key: getKey(d, keygen, groupIndex + i),
              isActive: isActive,
              disabled: datum.disabled(d),
              data: d,
              columns: columns,
              multiple: multiple,
              onClick: onChange,
              renderItem: renderItem,
              __self: _this2,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 63,
                columnNumber: 13
              }
            })
          );
        }))
      );
    }
  }, {
    key: "renderHeader",
    value: function renderHeader(count) {
      cov_1hbovy3e54.f[7]++;

      var _ref4 = (cov_1hbovy3e54.s[22]++, this.props),
          data = _ref4.data,
          loading = _ref4.loading,
          multiple = _ref4.multiple,
          columnsTitle = _ref4.columnsTitle;

      cov_1hbovy3e54.s[23]++;

      if ((cov_1hbovy3e54.b[5][0]++, loading) || (cov_1hbovy3e54.b[5][1]++, !multiple)) {
        cov_1hbovy3e54.b[4][0]++;
        cov_1hbovy3e54.s[24]++;
        return null;
      } else {
        cov_1hbovy3e54.b[4][1]++;
      }

      var checked = (cov_1hbovy3e54.s[25]++, 'indeterminate');
      cov_1hbovy3e54.s[26]++;

      if (count === 0) {
        cov_1hbovy3e54.b[6][0]++;
        cov_1hbovy3e54.s[27]++;
        checked = false;
      } else {
        cov_1hbovy3e54.b[6][1]++;
        cov_1hbovy3e54.s[28]++;

        if (count === data.length) {
          cov_1hbovy3e54.b[7][0]++;
          cov_1hbovy3e54.s[29]++;
          checked = true;
        } else {
          cov_1hbovy3e54.b[7][1]++;
        }
      }

      cov_1hbovy3e54.s[30]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: selectClass('header'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 89,
            columnNumber: 7
          }
        }, (cov_1hbovy3e54.b[8][0]++, multiple) && (cov_1hbovy3e54.b[8][1]++,
        /*#__PURE__*/
        React.createElement(Checkbox, {
          onChange: this.handleSelectAll,
          checked: checked,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 91,
            columnNumber: 11
          }
        }, this.getText('selectAll'))), (cov_1hbovy3e54.b[9][0]++, columnsTitle) && (cov_1hbovy3e54.b[9][1]++,
        /*#__PURE__*/
        React.createElement("span", {
          className: selectClass('header-title'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 95,
            columnNumber: 26
          }
        }, columnsTitle)))
      );
    }
  }, {
    key: "renderLazyList",
    value: function renderLazyList() {
      cov_1hbovy3e54.f[8]++;

      var _ref5 = (cov_1hbovy3e54.s[31]++, this.props),
          columns = _ref5.columns,
          height = _ref5.height,
          lineHeight = _ref5.lineHeight,
          data = _ref5.data,
          itemsInView = _ref5.itemsInView;

      var sliceData = (cov_1hbovy3e54.s[32]++, data.reduce(function (red, item) {
        cov_1hbovy3e54.f[9]++;
        var lastItem = (cov_1hbovy3e54.s[33]++, red[red.length - 1]);
        cov_1hbovy3e54.s[34]++;

        if (!lastItem) {
          cov_1hbovy3e54.b[10][0]++;
          cov_1hbovy3e54.s[35]++;
          lastItem = [];
          cov_1hbovy3e54.s[36]++;
          red.push(lastItem);
        } else {
          cov_1hbovy3e54.b[10][1]++;
        }

        cov_1hbovy3e54.s[37]++;

        if (lastItem.length >= columns) {
          cov_1hbovy3e54.b[11][0]++;
          cov_1hbovy3e54.s[38]++;
          red.push([item]);
        } else {
          cov_1hbovy3e54.b[11][1]++;
          cov_1hbovy3e54.s[39]++;
          lastItem.push(item);
        }

        cov_1hbovy3e54.s[40]++;
        return red;
      }, []));
      cov_1hbovy3e54.s[41]++;
      return (
        /*#__PURE__*/
        React.createElement(LazyList, {
          lineHeight: lineHeight,
          data: sliceData,
          itemsInView: itemsInView,
          height: height,
          renderItem: this.handleRenderItem,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 113,
            columnNumber: 7
          }
        })
      );
    }
  }, {
    key: "renderStack",
    value: function renderStack() {
      var _this3 = this;

      cov_1hbovy3e54.f[10]++;

      var _ref6 = (cov_1hbovy3e54.s[42]++, this.props),
          columns = _ref6.columns,
          datum = _ref6.datum,
          multiple = _ref6.multiple,
          onChange = _ref6.onChange,
          renderItem = _ref6.renderItem,
          data = _ref6.data,
          keygen = _ref6.keygen;

      cov_1hbovy3e54.s[43]++;
      return data.map(function (d, i) {
        cov_1hbovy3e54.f[11]++;
        var isActive = (cov_1hbovy3e54.s[44]++, datum.check(d));
        cov_1hbovy3e54.s[45]++;
        return (
          /*#__PURE__*/
          React.createElement(BoxOption, {
            key: getKey(d, keygen, i),
            isActive: isActive,
            disabled: datum.disabled(d),
            data: d,
            columns: columns,
            multiple: multiple,
            onClick: onChange,
            renderItem: renderItem,
            __self: _this3,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 128,
              columnNumber: 9
            }
          })
        );
      });
    }
  }, {
    key: "renderOptions",
    value: function renderOptions() {
      cov_1hbovy3e54.f[12]++;

      var _ref7 = (cov_1hbovy3e54.s[46]++, this.props),
          loading = _ref7.loading,
          columns = _ref7.columns,
          data = _ref7.data,
          renderPending = _ref7.renderPending,
          emptyText = _ref7.emptyText;

      cov_1hbovy3e54.s[47]++;

      if (loading) {
        cov_1hbovy3e54.b[12][0]++;
        cov_1hbovy3e54.s[48]++;
        return null;
      } else {
        cov_1hbovy3e54.b[12][1]++;
      }

      var stack = (cov_1hbovy3e54.s[49]++, columns === -1);
      var empty = (cov_1hbovy3e54.s[50]++, (cov_1hbovy3e54.b[13][0]++, renderPending) || (cov_1hbovy3e54.b[13][1]++, data.length === 0));
      cov_1hbovy3e54.s[51]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: selectClass('box-options', (cov_1hbovy3e54.b[14][0]++, stack) && (cov_1hbovy3e54.b[14][1]++, 'scrollable')),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 148,
            columnNumber: 7
          }
        }, empty ? (cov_1hbovy3e54.b[15][0]++,
        /*#__PURE__*/
        React.createElement("div", {
          key: "empty",
          className: selectClass('no-data'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 150,
            columnNumber: 11
          }
        }, (cov_1hbovy3e54.b[16][0]++, emptyText) || (cov_1hbovy3e54.b[16][1]++, this.getText('noData')))) : (cov_1hbovy3e54.b[15][1]++,
        /*#__PURE__*/
        React.createElement(React.Fragment, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 154,
            columnNumber: 11
          }
        }, stack ? (cov_1hbovy3e54.b[17][0]++, this.renderStack()) : (cov_1hbovy3e54.b[17][1]++, this.renderLazyList()))))
      );
    }
  }, {
    key: "render",
    value: function render() {
      cov_1hbovy3e54.f[13]++;

      var _ref8 = (cov_1hbovy3e54.s[52]++, this.props),
          data = _ref8.data,
          datum = _ref8.datum,
          style = _ref8.style,
          loading = _ref8.loading,
          focus = _ref8.focus,
          selectId = _ref8.selectId,
          getRef = _ref8.getRef,
          customHeader = _ref8.customHeader,
          renderOptionList = _ref8.renderOptionList;

      var checkedCount = (cov_1hbovy3e54.s[53]++, data.filter(function (d) {
        cov_1hbovy3e54.f[14]++;
        cov_1hbovy3e54.s[54]++;
        return datum.check(d);
      }).length);
      var newStyle = (cov_1hbovy3e54.s[55]++, Object.assign({}, style, {
        width: this.getWidth()
      }));
      var results = (cov_1hbovy3e54.s[56]++,
      /*#__PURE__*/
      React.createElement(React.Fragment, null, customHeader, (cov_1hbovy3e54.b[19][0]++, loading) && (cov_1hbovy3e54.b[19][1]++, typeof loading === 'boolean') ? (cov_1hbovy3e54.b[18][0]++,
      /*#__PURE__*/
      React.createElement(Spin, {
        size: 30,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 168,
          columnNumber: 52
        }
      })) : (cov_1hbovy3e54.b[18][1]++, loading), this.renderHeader(checkedCount), this.renderOptions()));
      cov_1hbovy3e54.s[57]++;
      return (
        /*#__PURE__*/
        React.createElement(ScaleList, {
          show: focus,
          onMouseMove: this.handleMouseMove,
          "data-id": selectId,
          style: newStyle,
          className: selectClass('box-list'),
          getRef: getRef,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 175,
            columnNumber: 7
          }
        }, getCustomList(results, renderOptionList, loading))
      );
    }
  }]);

  return BoxList;
}(Component);

BoxList.defaultProps = DefaultValue;
export default BoxList;